<template>
  <div class="action">
    <div class="box" v-for="(item, index) in list" :key="index" @click="roam(index)">
      {{ item }}
    </div>
  </div>
</template>

<script>
import { check_code } from "../assets/api/index";
export default {
  data() {
    return {
      list: [
        this.$t("info.lang.roam1"),
        this.$t("info.lang.roam2"),
        this.$t("info.lang.roam3"),
        this.$t("info.lang.roam4"),
        this.$t("info.lang.roam5"),
      ],
    };
  },
  methods: {
    roam(key) {
      var index = key;

      console.log(this.$chat.role.auth);
      if (this.$chat.role.auth < 3 && index > 1) {
        this.$message.error("您暂无权限");
        return;
      }
      localStorage.setItem("olytype", index);
      location.reload();
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  width: 66px;

  position: absolute;
  right: 120px;
  top: 90px;
  z-index: 1;
  .box {
    width: 135px;
    height: 30px;
    background: #ffffff;
    border-radius: 17px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #333333;
  }
}
</style>
